"use client";

import { Actions } from "@/lib/permissions";
import { getUserAction } from "@/server-actions/get-user-action";
import { UsersPermissionsUserQuery } from "@/types/generated";
import WebmLoader from "@/views/loader";
import { usePathname } from "next/navigation";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

export type User = UsersPermissionsUserQuery["usersPermissionsUser"] | null;

interface UserContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  token: string | null;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider = ({
  children,
  isLoggedIn,
}: {
  children: ReactNode;
  isLoggedIn: boolean;
}) => {
  const path = usePathname();
  const [user, setUserState] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(isLoggedIn);

  const setUser = (user: User | null) => {
    setUserState(user);
  };

  useEffect(() => {
    const fetchUser = async () => {
      setIsLoading(true);
      try {
        const userData = await getUserAction(); // this runs on server, reads from httpOnly cookie
        if (userData) {
          setUser(userData?.userData);
          setToken(userData?.token);
        } else {
          setUser(null);
        }
      } catch (err) {
        setUser(null);
      }
      setIsLoading(false);
    };
    if (isLoggedIn) {
      fetchUser();
    }
  }, [isLoggedIn]);

  //   if (typeof window !== "undefined" && isLoggedIn) {
  //     return (
  return (
    <UserContext.Provider value={{ user, setUser, setToken, token }}>
      {isLoading ? (
        <WebmLoader src={"/loader/1746511833258.webm"} width={150} />
      ) : (
        children
      )}
    </UserContext.Provider>
  );
  // );
  //   } else {
  //     return (
  //       <UserContext.Provider value={{ user, setUser, setToken, token }}>
  //         {children}
  //       </UserContext.Provider>
  //     );
  //   }
};

export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

export const useCan = () => {
  const { user } = useUser();

  const can = (action: Actions[]) => {
    if (!user) return false;
    const permissions = user?.role?.permissions || [];
    return permissions.some((permission) =>
      action.includes(permission?.action as Actions)
    );
  };

  return { can };
};
